import {
getCalenderList
} from '@/api/calender'

const state = {
};

const mutations = {
};

const actions = {
  getcalenderlist({commit},data){
    return new Promise((resolve, reject) => {
      getCalenderList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
